import axios from 'axios';

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/**
*

0 = Unknown

1 = Minor

2 = Moderate

3 = Severe

4 = Extreme

5 = Impossible
* @format int32
*/
var Severity;
(function (Severity) {
    Severity[Severity["Unknown"] = 0] = "Unknown";
    Severity[Severity["Minor"] = 1] = "Minor";
    Severity[Severity["Moderate"] = 2] = "Moderate";
    Severity[Severity["Severe"] = 3] = "Severe";
    Severity[Severity["Extreme"] = 4] = "Extreme";
    Severity[Severity["Impossible"] = 5] = "Impossible";
})(Severity || (Severity = {}));
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title Futhark.Gyfu.NPAS.Api
 * @version 1.0
 */
class Api extends HttpClient {
    api = {
        /**
         * No description
         *
         * @tags Alert
         * @name AlertCheckDetail
         * @summary Get user alerts ids
         * @request GET:/api/alert/check/{sessionId}
         * @response `200` `(number)[]` Success
         */
        alertCheckDetail: (sessionId, params = {}) => this.request({
            path: `/api/alert/check/${sessionId}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Alert
         * @name AlertCheckandretrieveDetail
         * @summary Get user alerts by session id
         * @request GET:/api/alert/checkandretrieve/{sessionId}
         * @response `200` `(UserAlert)[]` Success
         */
        alertCheckandretrieveDetail: (sessionId, params = {}) => this.request({
            path: `/api/alert/checkandretrieve/${sessionId}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Alert
         * @name AlertRetrieveCreate
         * @summary Get alerts by ids
         * @request POST:/api/alert/retrieve
         * @response `200` `(UserAlert)[]` Success
         */
        alertRetrieveCreate: (data, params = {}) => this.request({
            path: `/api/alert/retrieve`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Alert
         * @name AlertAckCreate
         * @summary Marks user alerts as read
         * @request POST:/api/alert/ack
         * @response `200` `boolean` Success
         */
        alertAckCreate: (data, params = {}) => this.request({
            path: `/api/alert/ack`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
}

export { Api, ContentType, HttpClient, Severity };
